export function replaceSpaces(name) {
  return name.replace(/\s/g, "-");
}

export function replaceDashes(name) {
  return name.replace(/-/g, " ");
}
